import React, { useCallback } from 'react'
import { Form, Text, RadioGroupField } from '@adc/ui-adc'
import _cx from 'classnames/bind'
import {
  californiaSpecialTreatmentRadioOptions,
  radioOptions,
} from './radioOptions'
import { Context, FirstLookFlowData } from './firstLookFlow'
// @ts-ignore no types
import cls from './styles.scss'

const cx = _cx.bind(cls)
type BasicInformationStepProps = {
  context: Context
  data: FirstLookFlowData
  setData: (data: FirstLookFlowData) => void
}

const BasicInformationStep = ({
  context,
  data,
  setData,
}: BasicInformationStepProps) => {
  const { isCaliforniaSpecialTreatmentRequired, isMobile } = context

  const onOptionChange = useCallback(
    (_e: any, { value }: { value?: string } = {}) => {
      setData({
        ...data,
        selection: value || '',
      } as FirstLookFlowData)
    },
    [setData]
  )

  return (
    <Form>
      <Text
        size={!isMobile ? 'big' : 'huge'}
        className={cx('title-center')}
        weight={'heavy'}
      >
        Who will purchase this property?
      </Text>
      <RadioGroupField
        label=''
        options={
          isCaliforniaSpecialTreatmentRequired
            ? californiaSpecialTreatmentRadioOptions
            : radioOptions
        }
        elmId='selection'
        name='selection'
        compact={false}
        onChange={onOptionChange}
        value={data.selection}
      />
    </Form>
  )
}
export default BasicInformationStep
